import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { handleResponse } from 'src/functions/http-handler';
import { IPagedList } from 'src/models/paged-list.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NoticeService {
  private _apiUrl: string;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private logger: NGXLogger) {
    this._apiUrl = `${baseUrl}api/Notice`;
  }

  getNotice(categories: Array<string>, pageNum: number, pageSize: number) {
    this.logger.log('categories', categories);
    this.logger.log('pageNum', pageNum);
    this.logger.log('pageSize', pageSize);
    const param = { categoryIds: categories, pageNum: pageNum.toString(), pageSize: pageSize.toString() };
    return this.http.get(this._apiUrl, { params: param })
      .pipe(handleResponse<IPagedList<INotice>>(this.logger, 'retrieve notice'));
  }

  retrieveAll() {
    const param = { categoryIds: [], pageNum: "0", pageSize: "1000" };
    return this.http.get(this._apiUrl, { params: param })
      .pipe(
        handleResponse<IPagedList<INotice>>(this.logger, 'retrieve notice'),
        map((data: IPagedList<INotice>) => {
          return data.items;
        }));
  }

  createNotice(notice: INotice) {
    return this.http.post(this._apiUrl, notice)
      .pipe(handleResponse<INotice>(this.logger, 'create notice'));
  }  

  updateNotice(notice: INotice) {
    return this.http.put(`${this._apiUrl}/${notice.id}`, notice)
      .pipe(handleResponse<INotice>(this.logger, 'update notice'));
  }
  readNotice(notice: INotice) {
    return this.http.get(`${this._apiUrl}/${notice.id}`)
      .pipe(handleResponse<INotice>(this.logger, 'read notice'));
  }

  deleteNotice(notice: INotice) {
    return this.http.delete(`${this._apiUrl}/${notice.id}`)
      .pipe(handleResponse<INotice>(this.logger, 'delete notice'));
  }
}

export interface INotice {
  id: number,
  category: string,
  title: string,
  content: string,
  viewCount: number,
  isPopup: boolean,
  dateFrom: Date,
  dateTo: Date,
  crtId: string,
  crtDt: Date,
  attachmentId: string,
  fileName: string,
}
